<p-dialog
  [(visible)]="isVisible"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="onClose()"
  >

  <ng-template pTemplate="header">
    <div class="d-flex align-items-center gap-3 w-full">
      <i class="pi pi-credit-card" style="font-size: 1.5rem"></i>

      <div class="flex-1">
        <div class="d-flex align-items-center gap-2 mb-1">
          <h3 class="m-0 text-black">{{ modalTitle }}</h3>

          <p-tag
            [value]="plan?.isActive ? 'ACTIVE' : 'INACTIVE'"
            [severity]="plan?.isActive ? 'success' : 'danger'"
            styleClass="p-1 text-xs font-semibold">
          </p-tag>
        </div>

        <small class="text-500 text-black">
          {{ plan?.subscriptionType | titlecase }} • {{ plan?.platform | titlecase }}
        </small>
      </div>
    </div>
  </ng-template>

  <!-- ===== BODY ===== -->
  @if (plan) {
    <div class="plan-modal-body">
      <div class="plan-info">
        <div class="info-row">
          <label>Plan Name:</label>
          <span class="plan-name">{{ plan.name }}</span>
        </div>
        <div class="info-row">
          <label>Description:</label>
          <span class="plan-features">{{ plan.description }}</span>
        </div>
        <div class="info-row">
          <label>Price:</label>
          <span class="plan-price">
            {{ plan.price | currency: plan.currency:'symbol':'1.2-2' }}
            / {{ plan.duration }} days
          </span>
        </div>
        <div class="info-row">
          <label>Product ID:</label>
          <code class="plan-features">{{ plan.productId }}</code>
        </div>
        <div class="info-row">
          <label>App Store ID:</label>
          <code class="plan-features">{{ plan.appStoreProductId }}</code>
        </div>
        <div class="info-row">
          <label>Play Store ID:</label>
          <code class="plan-features">{{ plan.playStoreProductId }}</code>
        </div>
        <!-- Daily Limits Section -->
        <div class="limits-section">
          <label class="section-label">Daily Limits</label>
          <div class="limits-list">
            <div class="limit-row">
              <span>Swipes</span>
              <strong>{{ plan.limits.dailySwipes }}</strong>
            </div>
            <div class="limit-row">
              <span>Pops</span>
              <strong>{{ plan.limits.dailyPops }}</strong>
            </div>
            <div class="limit-row">
              <span>Super Likes</span>
              <strong>{{ plan.limits.dailySuperLikes }}</strong>
            </div>
            <div class="limit-row">
              <span>Rewinds</span>
              <strong>{{ plan.limits.dailyRewinds }}</strong>
            </div>
          </div>
        </div>
        <!-- Features as chips -->
        <div class="info-row">
          <label>Features:</label>
          <div class="features-row">
            @for (feature of plan.features || []; track feature) {
              <span class="feature-chip">
                {{ feature }}
              </span>
            }
          </div>
        </div>
        <div class="info-row">
          <label>Created At:</label>
          <span class="plan-users">{{ plan.createdAt | date:'medium' }}</span>
        </div>
        <div class="info-row">
          <label>Updated At:</label>
          <span class="plan-users">{{ plan.updatedAt | date:'medium' }}</span>
        </div>
      </div>
    </div>
  }

</p-dialog>
